import { ReactNode } from 'react'

import { MpxResponseError } from '@cibo/core'
import { Markdown } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'

interface StatusMapObject {
  title: string
  body: string
}

interface Props {
  error?: MpxResponseError
  defaultMessage: string
  statusMap?: {
    [key: number]: string | StatusMapObject
  }
  before?: ReactNode
  after?: ReactNode
}

export const HttpErrorDisplay = ({ error, defaultMessage, statusMap, before, after }: Props) => {
  if (!error) {
    return null
  }

  let errorTitle: string = defaultMessage
  let errorMessage = ''

  if (statusMap && error.httpCode && statusMap[error.httpCode]) {
    if (typeof statusMap[error.httpCode] === 'string') {
      errorTitle = statusMap[error.httpCode] as string
    } else if (typeof statusMap[error.httpCode] === 'object') {
      const { body, title } = statusMap[error.httpCode] as StatusMapObject
      errorTitle = title
      errorMessage = body
    }
  }

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        <WarningIcon color="warning" />
        <Typography variant="h5">{errorTitle}</Typography>
      </Stack>
      {!!errorMessage && <Markdown>{errorMessage}</Markdown>}
    </>
  )
}
